import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=9ec1fba6"
import script from "./ProductImage.vue?vue&type=script&lang=ts"
export * from "./ProductImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports